var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7687 2.76518L6.07356 0.632643C6.01734 0.61171 5.955 0.61171 5.89875 0.632643L0.163839 2.78008C0.0631575 2.80937 -0.0585791 2.96833 0.0314776 3.131V9.15247C0.0314776 9.25887 0.0989164 9.35335 0.199476 9.38818L5.84281 11.336C5.8763 11.3552 5.90212 11.3721 5.96128 11.38C6.04418 11.3909 6.09664 11.3677 6.09704 11.3676L11.8319 9.38818C11.9325 9.35335 12 9.25887 12 9.15247V3.01359C12.0021 2.8941 11.8619 2.79823 11.7687 2.76518ZM11.0101 3.01359L6.00112 4.8893L4.49792 4.32653L9.26869 2.3615L11.0101 3.01359ZM8.58272 2.10462L3.56944 4.16948L3.44599 5.3687L2.51264 4.99274V3.87972L7.71232 1.77866L8.58272 2.10462ZM5.98617 1.13232L7.02171 1.52007L2.20246 3.46705L0.976988 3.00807L5.98617 1.13232ZM0.530197 3.3843L2.01397 3.93995V5.32925L3.87429 6.07877L4.01723 4.68994L5.76641 5.34498V10.782L0.530197 8.97473V3.3843ZM11.5013 8.9747L6.26508 10.7819V5.33389L11.5013 3.37323V8.9747Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.9fd25e07de5a68baac06f4af5f12b14c.svg";
export { ForwardRef as ReactComponent };